import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  submit() {
    const url = new URL(window.location)
    url.searchParams.set("sort", this.element.value)
    url.searchParams.set("filtered", "1")
    url.searchParams.delete("all_properties_page")
    window.location = url.toString()
  }
}
